var map = {
	"./cocon/cocon.woff": 27,
	"./cocon/cocon.woff2": 28,
	"./open-sans/open-sans-bold.eot": 29,
	"./open-sans/open-sans-bold.svg": 30,
	"./open-sans/open-sans-bold.ttf": 31,
	"./open-sans/open-sans-bold.woff": 32,
	"./open-sans/open-sans-bold.woff2": 33,
	"./open-sans/open-sans-regular.eot": 34,
	"./open-sans/open-sans-regular.svg": 35,
	"./open-sans/open-sans-regular.ttf": 36,
	"./open-sans/open-sans-regular.woff": 37,
	"./open-sans/open-sans-regular.woff2": 38
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 26;